<template>
  <div>
    <v-text-field
      v-model.trim="searchText"
      placeholder="Table | TicketNo"
      solo
      flat
      hide-details
      prepend-inner-icon="search"
      clearable
      append-icon="filter_list"
      @click:append="openFilter()"
      @input="act()"
    ></v-text-field>

    <!-- <v-btn :disabled="disabled" color="primary" outline icon @click="openFilter()">
      <v-icon>filter_list</v-icon>
    </v-btn>-->
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      full-width
      bottom
      origin="center right"
      transition="slide--transition"
      :position-x="1200"
      :position-y="menuY"
    >
      <!-- <span slot="activator"></span> -->
      <v-card max-width="650">
        <v-layout row wrap>
          <v-flex xs12 md6 class="px-3 py-2">
            <span class="subheading font-weight-medium">Sale Entry</span>
            <v-divider></v-divider>
            <v-list dense>
              <v-switch
                v-for="saleType in saleTypes"
                :key="saleType.id"
                :value="saleType.id"
                color="info"
                v-model="selectedSaleTypes"
                @change="act()"
                class="v-height"
              >
                <div slot="label">{{ saleType.name }}</div>
                <div slot="append"></div>
              </v-switch>
            </v-list>
          </v-flex>
          <v-flex xs12 md6 class="px-3 py-2">
            <span class="subheading font-weight-medium">Service type</span>
            <v-divider></v-divider>
            <v-list dense>
              <v-switch
                v-for="service in serviceTypes"
                :key="service.id"
                :value="service.id"
                color="info"
                v-model="selectedServiceTypes"
                @change="act()"
                class="v-height"
              >
                <div slot="label">{{ service.displayName }}</div>
                <div slot="append">
                  <v-icon :color="service.color">{{ service.icon }}</v-icon>
                </div>
              </v-switch>
            </v-list>
          </v-flex>
          <!-- <v-flex xs6 class="px-3 py-2">
            <span class="subheading font-weight-medium">Check Status</span>
            <v-divider></v-divider>
            <v-list dense>
              <div v-for="status_type in statusTypes" :key="status_type.name">
                <v-switch
                  :value="status_type.status"
                  color="success"
                  v-model="selectedStatus"
                  @change="act()"
                  class="v-height"
                >
                  <div slot="label">{{ status_type.name }}</div>
                  <div slot="append">
                    <v-icon :color="status_type.color">blur_circular</v-icon>
                  </div>
                </v-switch>
              </div>
            </v-list>
          </v-flex> -->
          <v-flex xs12 md6 class="px-3 py-2">
            <span class="subheading font-weight-medium">Item Status</span>
            <v-divider></v-divider>
            <v-list dense>
              <div
                v-for="status_type in itemStatusTypes"
                :key="status_type.name"
              >
                <v-switch
                  :value="status_type.status"
                  color="success"
                  v-model="selectedItemStatus"
                  @change="act()"
                  class="v-height"
                >
                  <div slot="label">{{ status_type.name }}</div>
                  <div slot="append">
                    <v-icon :color="status_type.color">blur_circular</v-icon>
                  </div>
                </v-switch>
              </div>
            </v-list>

            <v-checkbox v-model="splitByKotNo" color="primary" label="Split checks by KOT" @change="act()"></v-checkbox>
          </v-flex>
          <v-flex xs12 md6 class="px-3 py-2">
            <span class="subheading font-weight-medium">Item Sort</span>
            <div class="caption grey--text pb-2">
              Sort the items based on their kot numbers.
            </div>
            <v-divider></v-divider>
            <v-list dense>
              <v-radio-group v-model="sortOrder" class="pt-1">
                <v-radio
                  label="New items at bottom"
                  value="1"
                  color="primary"
                  @change="act()"
                ></v-radio>
                <v-radio
                  label="New items at top"
                  value="-1"
                  color="primary"
                  @change="act()"
                ></v-radio>
              </v-radio-group>
            </v-list>

            <span class="subheading font-weight-medium">Check Sort</span>
            <div class="caption grey--text pb-2">
              Sort the checks based on the kot number or token number.
            </div>
            <v-divider></v-divider>

            <span class="caption grey--text font-weight-medium pt-1">Sort By</span>
            <v-list dense class="pb-0 mt-0">
              <v-radio-group v-model="sortBy" class="pt-1">
                <v-radio
                  label="KOT Number"
                  value="1"
                  color="primary"
                  @change="act()"
                ></v-radio>
                <v-radio
                  label="Token Number"
                  value="2"
                  color="primary"
                  @change="act()"
                ></v-radio>
              </v-radio-group>
            </v-list>
            <span class="caption grey--text font-weight-medium">Sort Order</span>
            <v-list dense class="pt-0 mt-0">
              <v-radio-group v-model="checkSortOrder" class="pt-1">
                <v-radio
                  label="New checks at bottom"
                  value="1"
                  color="primary"
                  @change="act()"
                ></v-radio>
                <v-radio
                  label="New checks at top"
                  value="-1"
                  color="primary"
                  @change="act()"
                ></v-radio>
              </v-radio-group>
            </v-list>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <span>
            <v-btn outline small color="success" @click="reset()">
              Reset
            </v-btn>
            <v-btn outline small color="error" @click="menu = false">
              Close
            </v-btn>
          </span>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<style slot-scope>
.v-list .v-input,
.v-list .v-input__slot {
  margin: 0 !important;
}
</style>

<script>
export default {
  name: "check-search-bar",
  props: {
    search: {
      txt: String,
      selectedSaleTypes: Array,
      selectedServiceTypes: Array,
      selectedStatus: Array,
      selectedItemStatus: Array,
    },
    disabled: Boolean,
  },
  data() {
    return {
      searchText: "",
      menu: false,
      selectedSaleTypes: [],
      selectedServiceTypes: [],
      selectedStatus: [],
      selectedItemStatus: [2, 3],
      itemStatus: {
        prepared: false,
      },
      sortOrder: "1",
      checkSortOrder: "1",
      sortBy: "1",
      splitByKotNo: false
    };
  },
  methods: {
    act() {
      this.$nextTick(() => {
        this.$emit("update:search", {
          txt: this.searchText,
          selectedSaleTypes: this.selectedSaleTypes,
          selectedServiceTypes: this.selectedServiceTypes,
          selectedStatus: this.selectedStatus,
          selectedItemStatus: this.selectedItemStatus,
          sortOrder: this.sortOrder,
          checkSortOrder: this.checkSortOrder,
          sortBy: this.sortBy,
          splitByKotNo: this.splitByKotNo,
        });
        this.savePreference();
      });
    },
    openFilter() {
      this.menu = true;
    },
    reset() {
      this.selectedSaleTypes = [];
      this.selectedServiceTypes = [];
      this.selectedStatus = [];
      this.selectedItemStatus = [2, 3];
      this.sortOrder = "1";
      this.checkSortOrder = "1";
      this.splitByKotNo = false;
      this.sortBy = "1";
      this.resetPreferences();
      this.act();
    },
    savePreference() {
      let obj = {
        serviceTypes: this.selectedServiceTypes,
        saleTypes: this.selectedSaleTypes,
        statusTypes: this.selectedStatus,
        itemStatus: this.selectedItemStatus,
        sortOrder: this.sortOrder,
        checkSortOrder: this.checkSortOrder,
        splitByKotNo: this.splitByKotNo,
        sortBy: this.sortBy,
      };
      this.$store.commit("setPreferences", obj);
    },
    resetPreferences() {
      this.$store.commit("resetPreferences");
    },
  },
  computed: {
    menuY() {
      return this.$vuetify.breakpoint.name == "xs" ? 97 : 49;
    },
    saleTypes() {
      return this.$store.getters.defaultSaleTypes;
    },
    serviceTypes() {
      return this.$store.getters.defaultServiceTypes;
    },
    statusTypes() {
      return this.$store.getters.statusTypes;
    },
    itemStatusTypes() {
      return this.$store.getters.itemStatusTypes;
    },
  },
  mounted() {
    let pre = this.$store.getters.getPreferences;
    this.selectedSaleTypes = pre.saleTypes;
    this.selectedServiceTypes = pre.serviceTypes;
    this.selectedStatus = pre.statusTypes;
    this.selectedItemStatus = pre.itemStatus;
    this.sortOrder = pre.sortOrder;
    this.checkSortOrder = pre.checkSortOrder;
    this.splitByKotNo = pre.splitByKotNo;
    this.sortBy = pre.sortBy;
  },
};
</script>
<style scoped>
.v-height {
  height: 28px;
}
</style>
